import { LeftOutlined, RightOutlined } from "@ant-design/icons";
import { pdf, PDFDownloadLink } from "@react-pdf/renderer";
import {
  Button,
  Drawer,
  Dropdown,
  Menu,
  message,
  Pagination,
  PaginationProps,
  Row,
  Space,
  Tag,
} from "antd";
import copy from "clipboard-copy";
import { saveAs } from "file-saver";
import _ from "lodash";
import moment from "moment";
import { useEffect, useState } from "react";
import { useLocation, useNavigate, useSearchParams } from "react-router-dom";
import { CommonButton } from "../../components/CommonButton/button";
import QuotationFilter from "../../components/CommonFilter/quotationFilter";
import { Text } from "../../components/CommonFont/text";
import { SearchBox } from "../../components/CommonSearchBox";
import { CommonTable } from "../../components/commonTable";
import { TableCard } from "../../components/CommonTableCard";
import { AddNewQuotation } from "../../components/Drawer/AddNewQuotation";
import { QuotationExport } from "../../components/Export/quotationExport";
import { getContactsParams } from "../../helpers/quarery";
import {
  useExportSalesReportMutation,
  useGetEnquiryCategoryQuery,
  useGetQuotationDownloadDataQuery,
  useGetQuotationQuery,
  useGetQuotationShareQuery,
  useGetSalesAfterNpdQuotationQuery,
  useGetSalesAfterQuotationQuery,
  useLazyGetSalesAfterQuotationQuery,
} from "../../services/api";
import "./index.css";
import {
  getDefaultQuotationSelectedColumns,
  QuotationColumnLabels,
  QuotationExportColumn,
  QuotationTableColumn,
  statusFilterOptions,
} from "./quotationColumns";
import ExportModal from "../../components/Modals/ReportsModal/ExportModal";
import MultiSelectFilter from "../../components/Modals/ReportsModal/MultiSelectFilter";

export const Quotation = () => {
  const [open, setOpen] = useState(false);
  const [id, setId] = useState("");
  const location = useLocation();
  const [selectedRegion, setSelectedRegion] = useState([]);
  const [isInProgress, setIsProgress] = useState(false);
  const [isDispatch, setDispatch] = useState(false);
  const [isStatus, setStatus] = useState(0);
  const [quotationType, setQuotationType] = useState<string>("sales_lead");
  const [selectedStatus, setSelectedStatus] = useState<string[]>([]);
  const [exportStatusFilter, setExportStatusFilter] = useState<string[]>([]);

  const isQuotation = location.pathname;
  const isQuotationUrl =
    isQuotation && isQuotation.includes("/quotation/details");
  const onClose = () => {
    setOpen(false);
    setDownloadQuotationdta(undefined);
    navigate("/quotation");
  };
  const [downloadIds, setDownloadIds] = useState<any>();
  const [editData, setEditData] = useState<any>();

  const [filterData, setFilterData] = useState<any>();
  const [downloadQuotationdta, setDownloadQuotationdta] = useState<any>();  

  const [filter, setFilter] = useState(false);

  // ---------------modal---------------

  // Enquiry Category filter states
  const [enquiryCategoryIds, setEnquiryCategoryIds] = useState<number[]>([]);

  // Column selection state using enum
  const [selectedColumns, setSelectedColumns] = useState<
    Record<string, boolean>
  >(getDefaultQuotationSelectedColumns());
  const [isModalOpen, setIsModalOpen] = useState(false);

  // Export mutation
  const [exportSalesReport, { isLoading: isExporting }] =
    useExportSalesReportMutation();

  // Fetch data for enquiry category filter
  const { data: enquiryCategoryData } = useGetEnquiryCategoryQuery({});

  const showModal = () => {
    setIsModalOpen(true);
  };

  const resetModalFilters = () => {
    setEnquiryCategoryIds([]);
    setExportStatusFilter([]);
    setSelectedColumns(getDefaultQuotationSelectedColumns());
  };

  const handleCancel = () => {
    setIsModalOpen(false);
    resetModalFilters();
  };

  // ---------------modal---------------

  const [pageData, setPageData] = useState<{
    page: number;
    pageSize: number;
  }>({
    page: 1,
    pageSize: 5,
  });
  const onPaginationChange = (page: number, pageSize: number) => {
    setPageData({ page, pageSize });
  };
  const params = getContactsParams(pageData.page, pageData.pageSize);
  const [searchParams, setSearchParams] = useSearchParams();

  const search = searchParams.get("search");

  const userId = localStorage.getItem("user_id");
  const getAllQuotationParams = {
    id: userId,
    params: params,
    search: search ? search : "",
    body: JSON.stringify(filterData)
      ? JSON.stringify(filterData)
      : JSON.stringify({}),
    quotationType: quotationType,
  };
  const { data, isLoading, isFetching, refetch } = useGetQuotationQuery(
    getAllQuotationParams,
  );

  useEffect(() => {
    refetch();
  }, [filterData]);

  const Companyname = ({ id, npd_id }: any) => {
    const { data: quotationData, isLoading: loadingQuery } =
      useGetSalesAfterQuotationQuery(id);
    const { data: npdData, isLoading } = useGetSalesAfterNpdQuotationQuery(
      npd_id && npd_id,
    );
    // useEffect(() => {
    //   if (id) {
    //     trigger(id);
    //   }
    // }, [id]);
    return (
      <>
        <div>
          {quotationData?.data[0]?.company_name
            ? quotationData?.data[0]?.company_name
            : npdData?.data[0]?.company_name}
        </div>
      </>
    );
  };
  const LeadName = ({ id, npd_id }: any) => {
    const { data: quotationData, isLoading: loadingQuery } =
      useGetSalesAfterQuotationQuery(id);
    const { data: npdData, isLoading } = useGetSalesAfterNpdQuotationQuery(
      npd_id && npd_id,
    );
    // useEffect(() => {
    //   if (id) {
    //     trigger(id);
    //   }
    // }, [id]);
    return (
      <>
        <div>
          {quotationData?.data[0]?.lead_name
            ? quotationData?.data[0]?.lead_name
            : npdData?.data[0]?.lead_name}
        </div>
      </>
    );
  };
  const EnquiryName = ({ id, npd_id }: any) => {
    const { data: quotationData, isLoading: loadingQuery } =
      useGetSalesAfterQuotationQuery(id);
    const { data: npdData, isLoading } = useGetSalesAfterNpdQuotationQuery(
      npd_id && npd_id,
    );
    // useEffect(() => {
    //   if (id) {
    //     trigger(id);
    //   }
    // }, [id]);

    return (
      <>
        <div>
          {" "}
          {quotationData?.data[0]?.enquiry_category_name
            ? quotationData?.data[0]?.enquiry_category_name
            : npdData?.data[0]?.enquiry_category_name}
        </div>
      </>
    );
  };
  const CUINo = ({ id, npd_id }: { id: number; npd_id: number }) => {
    const { data: quotationData, isLoading: loadingQuery } =
      useGetSalesAfterQuotationQuery(id);
    const { data: npdData, isLoading } = useGetSalesAfterNpdQuotationQuery(
      npd_id && npd_id,
    );

    // useEffect(() => {
    //   if (id) {
    //     trigger(id);
    //   }
    // }, [id]);

    return (
      <>
        <div>
          {" "}
          {quotationData?.data[0]
            ?.contacts_customer_unique_identification_number
            ? quotationData?.data[0]
                ?.contacts_customer_unique_identification_number
            : npdData?.data[0]
                ?.contacts_customer_unique_identification_number
              ? npdData?.data[0]
                  ?.contacts_customer_unique_identification_number
              : "-"}
        </div>
      </>
    );
  };
  const Code = ({ id, npd_id }: any) => {
    const { data: quotationData, isLoading: loadingQuery } =
      useGetSalesAfterQuotationQuery(id);
    const { data: npdData, isLoading } = useGetSalesAfterNpdQuotationQuery(
      npd_id && npd_id,
    );
    // useEffect(() => {
    //   if (id) {
    //     trigger(id);
    //   }
    // }, [id]);

    return (
      <>
        <div>
          {" "}
          {quotationData?.data[0]?.sales_lead_id
            ? quotationData?.data[0]?.sales_lead_id
            : npdData?.data[0]?.code
              ? npdData?.data[0]?.code
              : "-"}
        </div>
      </>
    );
  };
  const idArray = _.map(data?.results, "id");
  const navigate = useNavigate();
  const handleDownload = () => {
    if (downloadedData) {
      saveAs(downloadedData, "quotation-export.xlsx");
    } else {
      message.error("Error: Downloaded data is undefined.");
    }
  };
  const { data: downloadedData, isFetching: downloadLoading } =
    useGetQuotationDownloadDataQuery(
      downloadIds?.length > 0 ? downloadIds : idArray,
    );
  // const [trigger, { data: downloadedData, isLoading: downloadLoading }] =
  //   useLazyGetQuotationDownloadDataQuery();

  const findIndexForObject = (array: [], object: any) => {
    return _.findIndex(array, object);
  };
  const quotation_id = searchParams.get("id");

  const targetObject = { id: Number(quotation_id) };
  const index = findIndexForObject(data?.results, targetObject);

  const [currentIndex, setCurrentIndex] = useState(index);

  const getObjectAtIndex = (array: [], index: number) => {
    const object = _.get(array, index);
    return object;
  };

  useEffect(() => {
    setCurrentIndex(index);
  }, [index]);
  useEffect(() => {
    if (currentIndex > -1) {
      const updatedObject: any = getObjectAtIndex(data?.results, currentIndex);

      navigate(
        `/quotation/details?id=${updatedObject?.id}&created_by=${updatedObject?.lead}`,
      );
    }
  }, [currentIndex]);

  const handlePrevious = () => {
    if (currentIndex > 0) {
      setCurrentIndex(currentIndex - 1);

      // navigate(`/contacts?id=${object?.id}`);
    }
  };
  const handleNext = () => {
    // console.log("final object trance", !contactLoading && object?.id);
    // navigate(`/contacts?id=${object?.id}`);

    if (currentIndex < data?.results?.length - 1) {
      setCurrentIndex(currentIndex + 1);

      // navigate(`/contacts?id=${object?.id}`);
      // setSearchParams({ ["id"]: object?.id });
    }
  };
  const dataSource = [
    {
      key: "1",
      name: "Mike",
      age: 32,
      date: "11/05/2023",
      code: "CH 1",
      address: "10 Downing Street",
    },
    {
      key: "2",
      name: "John",
      age: 42,
      date: "11/05/2023",
      code: "CH 1",
      address: "10 Downing Street",
    },
  ];

  const columns = [
    {
      title: "Date",
      dataIndex: "date",
      sorter: (a: any, b: any) =>
        moment(a.date).valueOf() - moment(b.date).valueOf(),
      // sorter: (a: any, b: any) => a.age - b.age,
      ellipsis: true,
      render: (text: any) => (
        <>
          <div>{moment(text).format("DD-MM-YYYY")}</div>
        </>
      ),
    },
    {
      title: "CUI No.",
      dataIndex: "contacts_customer_unique_identification_number",
      // sorter: (a: any, b: any) => {
      //   const cuiA = a.contacts_customer_unique_identification_number;
      //   const cuiB = b.contacts_customer_unique_identification_number;
      //   if (cuiA < cuiB) {
      //     return -1;
      //   }
      //   if (cuiA > cuiB) {
      //     return 1;
      //   }
      //   return 0;
      // },
      ellipsis: true,
      render: (text: any, record: any) => (
        <>
          <CUINo id={record.sales_lead} npd_id={record.npd} />
        </>
      ),
    },
    {
      title: "Code",
      dataIndex: "code",

      ellipsis: true,
      render: (text: any, record: any) => (
        <>
          <Code id={record.sales_lead} npd_id={record.npd} />
        </>
      ),
    },
    {
      title: "Lead Name",
      dataIndex: "lead_name",

      ellipsis: true,
      render: (text: any, record: any) => (
        <>
          <LeadName
            id={record.sales_lead && record.sales_lead}
            npd_id={record?.npd && record?.npd}
          />
        </>
      ),
    },
    {
      title: "Company",
      dataIndex: "company",

      ellipsis: true,
      render: (text: any, record: any) => (
        <>
          <Companyname
            id={record?.sales_lead && record?.sales_lead}
            npd_id={record?.npd && record?.npd}
          />
        </>
      ),
    },
    {
      title: "Enquiry Category",
      dataIndex: "sales_lead",

      ellipsis: true,
      render: (text: any, record: any) => (
        <>
          <EnquiryName
            id={record.sales_lead && record.sales_lead}
            npd_id={record.npd}
          />
        </>
      ),
    },
    {
      title: "Last Followed ",
      dataIndex: "status",

      ellipsis: true,
      render: (text: any) => (
        <>
          <div>
            {text?.date ? moment(text?.date).format("DD-MM-YYYY") : "-"}
          </div>
        </>
      ),
    },
    {
      title: "Status",
      dataIndex: "is_closed",
      ellipsis: true,
      render: (text: boolean | number | string) => {
        const isActive =
          text === false || text === "false" || text === 0 || text === "0";
        const label = isActive ? "Active" : "Closed";
        return <Tag color={isActive ? "green" : "red"}>{label}</Tag>;
      },
    },
  ];

  // Export columns (for sending to backend)
  const exportColumns = [
    {
      dataIndex: QuotationExportColumn.DATE,
      title: QuotationColumnLabels[QuotationTableColumn.DATE],
    },
    {
      dataIndex: QuotationExportColumn.CUI_NO,
      title: QuotationColumnLabels[QuotationTableColumn.CUI_NO],
    },
    {
      dataIndex: QuotationExportColumn.SALES_LEAD_ID,
      title: QuotationColumnLabels[QuotationTableColumn.SALES_LEAD_ID],
    },
    {
      dataIndex: QuotationExportColumn.LEAD_NAME,
      title: QuotationColumnLabels[QuotationTableColumn.LEAD_NAME],
    },
    {
      dataIndex: QuotationExportColumn.COMPANY_NAME,
      title: QuotationColumnLabels[QuotationTableColumn.COMPANY_NAME],
    },
    {
      dataIndex: QuotationExportColumn.ENQUIRY_CATEGORY_NAME,
      title: QuotationColumnLabels[QuotationTableColumn.ENQUIRY_CATEGORY_NAME],
    },
    {
      dataIndex: QuotationExportColumn.LAST_FOLLOWUP_DATE,
      title: QuotationColumnLabels[QuotationTableColumn.LAST_FOLLOWUP_DATE],
    },
    {
      dataIndex: QuotationExportColumn.STATUS,
      title: QuotationColumnLabels[QuotationTableColumn.STATUS],
    },
  ];

  const columnOptions = exportColumns.map((col) => ({
    dataIndex: col.dataIndex,
    title: col.title,
  }));
  // const { data: printData } = useGetQuotationByIdQuery(quotation_id);
  const createdBy = searchParams.get("created_by");

  const shareParams = {
    id: quotation_id,
    user_id: createdBy,
  };
  const {
    currentData: printData,
    isLoading: printLoading,
    isFetching: printFetching,
  } = useGetQuotationShareQuery(shareParams, { skip: !quotation_id });
  const isQuotationPdfReady = Boolean(
    quotation_id &&
      !printLoading &&
      !printFetching &&
      String(printData?.data?.id) === String(quotation_id) &&
      printData?.data?.items &&
      downloadQuotationdta?.data?.[0],
  );
  const handleQuotationPdfDownload = async (fileName: string) => {
    const selectedId = quotation_id;
    if (
      !selectedId ||
      printLoading ||
      printFetching ||
      !printData?.data ||
      String(printData.data.id) !== String(selectedId) ||
      !printData.data.items ||
      !downloadQuotationdta?.data?.[0]
    ) {
      return;
    }
    const blob = await pdf(
      <QuotationExport
        datas={printData?.data}
        salesData={downloadQuotationdta}
      />,
    ).toBlob();
    saveAs(blob, fileName);
  };

  const handleExportDownload = async () => {
    // Get selected columns array
    const selectedColumnsArray = (
      Object.keys(selectedColumns) as Array<keyof typeof selectedColumns>
    ).filter((key) => selectedColumns[key]);

    if (selectedColumnsArray.length === 0) {
      message.error("Please select at least one column to export");
      return;
    }

    try {
      // Build export payload for Quotations
      const exportPayload: any = {
        module: "quotation",
        columns: selectedColumnsArray,
      };

      // quotation_type to export payload
      exportPayload.quotation_type = quotationType;

      // Add enquiry category filter if selected
      if (enquiryCategoryIds && enquiryCategoryIds.length > 0) {
        exportPayload.enquiry_category_id = enquiryCategoryIds;
      }
      //status filter
      if (exportStatusFilter && exportStatusFilter.length === 1) {
        // Only apply filter if exactly ONE status is selected
        // If both are selected don't apply any status filter
        exportPayload.is_closed = exportStatusFilter[0] === "true" ? 0 : 1;
      }
      // Make the API call
      const response = await exportSalesReport(exportPayload).unwrap();

      if (response.status === "success" && response.file_url) {
        message.success(response.message || "Export completed successfully");

        // Fetch and download the file
        const fileResponse = await fetch(response.file_url);
        const blob = await fileResponse.blob();
        saveAs(blob, response.file_name);

        // Close modal and reset filters
        setIsModalOpen(false);
        resetModalFilters();
      } else {
        message.error(response.message || "Export failed. Please try again.");
      }
    } catch (error: any) {
      console.error("Export error:", error);
      if (error?.data) {
        message.error(
          error.data.message ||
            error.data.errorDetails ||
            "Export failed. Please try again.",
        );
      } else {
        message.error("Something went wrong. Please try again.");
      }
    }
  };

  const widgetMenu = (
    <Menu>
      <Menu.Item
        onClick={() => {
          if (editData?.data?.npd) {
            navigate(
              `/create-quotation?npd_id=${editData?.data?.npd}&quotation_id=${quotation_id}`,
            );
          }
          if (editData?.data?.sales_lead) {
            navigate(
              `/create-quotation?id=${editData?.data?.sales_lead}&quotation_id=${quotation_id}`,
            );
          }
        }}
      >
        <div className="logout-div">
          <Space>
            {/* <LoginOutlined className="logout-icon " /> */}
            <span className="logout-text ">Edit</span>
          </Space>
        </div>
      </Menu.Item>
      <Menu.Item
        disabled={!isQuotationPdfReady}
        onClick={() => {
          handleQuotationPdfDownload(
            `Quotation_${downloadQuotationdta?.data[0]?.sales_lead_id}.pdf`,
          );
        }}
      // onClick={() => {
      //   navigate("/profile");
      // }}
      >
        <div>Download</div>
      </Menu.Item>
      <Menu.Item
        onClick={() => {
          CopyButton();
        }}
      >
        <div className="logout-div">
          <Space>
            {/* <LoginOutlined className="logout-icon " /> */}
            <span className="logout-text ">Share</span>
          </Space>
        </div>
      </Menu.Item>
    </Menu>
  );
  const titleData = [
    "Date ",
    "CUI No.",
    "Code",
    "Lead Name",
    "Company",
    "Enquiry Category",
    "Last Followed",
    "Status",
  ];
  const [trigger, { data: salesData, isLoading: salesLoading }] =
    useLazyGetSalesAfterQuotationQuery();

  // useEffect(() => {
  //   if (printData?.data?.sales_lead) {
  //     trigger(printData?.data?.sales_lead);
  //   }
  // }, []);
  // const triggerDownload = () => {
  //   if (printData?.data?.sales_lead) {
  //     trigger(printData?.data?.sales_lead);
  //   }
  // };
  const CopyButton = () => {
    const currentURL = window?.location?.href;
    copy(currentURL)
      .then(() => {
        message.success("Link copied");
      })
      .catch((error) => {
        message.error("Failed to copy URL");
      });

    // navigator?.clipboard
    //   .writeText(currentURL && currentURL)
    //   .then(() => {
    //     message.success("Link copied");
    //   })
    //   .catch((error) => {
    //     message.error("Failed to copy URL");
    //   });
  };
  const onShowSizeChange: PaginationProps["onShowSizeChange"] = (
    current,
    pageSize,
  ) => {
    setPageData({
      page: current,
      pageSize: pageSize,
    });
  };
  useEffect(() => {
    setIsProgress(true);
    setStatus(0);
    setQuotationType("sales_lead");
  }, []);

  // Handle tab change for Leads
  const handleLeadsTab = () => {
    setIsProgress(true);
    setDispatch(false);
    setStatus(0);
    setQuotationType("sales_lead");
    setPageData((prev) => ({ ...prev, page: 1 }));
    // Reset status filter when switching tabs
    setSelectedStatus([]);
    // Clear any status filter from filterData
    if (filterData?.is_closed !== undefined) {
      const { is_closed, ...restFilterData } = filterData;
      setFilterData(restFilterData);
    }
  };
  // Handle tab change for NPD
  const handleNPDTab = () => {
    setIsProgress(false);
    setDispatch(true);
    setStatus(0);
    setQuotationType("npd");
    setPageData((prev) => ({ ...prev, page: 1 }));
    setSelectedStatus([]);
    // Clear any status filter from filterData
    if (filterData?.is_closed !== undefined) {
      const { is_closed, ...restFilterData } = filterData;
      setFilterData(restFilterData);
    }
  };

  // useEffect to watch for filterData changes and update the API params
  useEffect(() => {
    // The isStatus state is managed by filterData if status filter is present
    if (filterData?.is_closed !== undefined) {
      setStatus(filterData.is_closed);
    } else {
      // Reset to tab-based status when no status filter
      setStatus(0);
    }
  }, [filterData]);

  // useEffect(() => {
  //   const currentURL = window.location.href;

  //   localStorage.setItem("current_path", currentURL);
  // }, []);
  return (
    <>
      <div className="mt-24">
        <Text
          value="Quotation"
          variant="wearlay-display"
          className="quotation-title"
        />
        <div className="order-tab-main-div justify-end">
          {/* Updated tabs: Leads and NPD */}
          <div
            className={isInProgress ? "order-tabs-active" : "order-tabs"}
            onClick={handleLeadsTab}
          >
            Leads
          </div>
          <div
            className={isDispatch ? "order-tabs-active" : "order-tabs"}
            onClick={handleNPDTab}
          >
            NPD
          </div>
        </div>
        <div className="order-tab-main-div-2 ">
          <div className="flex m-inline-24 ">
            <div
              className={isInProgress ? "order-tabs-active" : "order-tabs"}
              onClick={handleLeadsTab}
            >
              Leads
            </div>
            <div
              className={isDispatch ? "order-tabs-active" : "order-tabs"}
              onClick={handleNPDTab}
            >
              NPD
            </div>
          </div>
        </div>
        <div className="p-10 mt-24p">
          <div className="flex justify-between">
            <Text value="Quotation Created" variant="wearlay-headline-2" />
            <div className="flex items-center h-full gap-2">
              <div className="search-resp ">
                <SearchBox placeholder="Search" />
              </div>
              <div className="relative">
                <CommonButton
                  variant="wearlay-with-icon"
                  icon={filter ? "/assets/close.svg" : "/assets/filter.svg"}
                  onClick={() => {
                    setFilter(!filter);
                  }}
                  className="download-btn-color"
                />

                {filter && (
                  <QuotationFilter
                    setFilter={setFilter}
                    setFilterData={setFilterData}
                    filer={filter}
                    setSelectedRegion={setSelectedRegion}
                    selectedRegion={selectedRegion}
                    selectedStatus={selectedStatus}
                    setSelectedStatus={setSelectedStatus}
                  />
                )}
              </div>
              <CommonButton
                variant="wearlay-with-icon"
                icon={
                  data?.results?.length === 0
                    ? "/assets/disabledDownload.svg"
                    : "/assets/download.svg"
                }
                onClick={showModal}
                // onClick={() => {
                //   handleDownload();
                // }}
                isLoading={downloadLoading}
                className="download-btn-color"
                disabled={data?.results?.length === 0 || downloadLoading}
              />
            </div>
          </div>
          <div className="resp-search">
            <SearchBox placeholder="Search" />
          </div>
          <div className="resp-table">
            <CommonTable
              datasource={data?.results}
              coloumn={columns}
              setDetailsOpen={setOpen}
              isLoading={isLoading || isFetching}
              setDownloadIds={setDownloadIds}
              setId={setId}
            />
            {data?.count > 0 && (
              <Row justify={"end"}>
                <Pagination
                  current={pageData.page}
                  onChange={onPaginationChange}
                  total={data?.count}
                  pageSize={pageData.pageSize}
                  responsive={true}
                  onShowSizeChange={onShowSizeChange}
                  showSizeChanger={data?.count > 10 ? true : false}
                />
              </Row>
            )}
          </div>
        </div>
      </div>
      <TableCard
        headingData={titleData}
        setOpen={setOpen}
        data={data?.results}
        loading={isLoading || isFetching}
      />
      {data?.count > 5 && (
        <Pagination
          current={pageData.page}
          onChange={onPaginationChange}
          total={data?.count}
          pageSize={pageData?.pageSize}
          className="pagination-resp"
          onShowSizeChange={onShowSizeChange}
          showSizeChanger={data?.count > 10 ? true : false}
        />
      )}
      <Drawer
        title={
          <div className="flex justify-between items-center">
            <Text value="Quotation Preview" variant="wearlay-subtitle" />
            <div className="quotation-option">
              <Space>
                <Button
                  className="flex items-center pdf-download-button"
                  onClick={() => {
                    // triggerDownload();
                    // navigate(`/export`);
                    // handleDownloadClick();
                  }}
                >
                  {isQuotationPdfReady ? (
                    <PDFDownloadLink
                      document={
                        <QuotationExport
                          datas={printData?.data}
                          salesData={downloadQuotationdta}
                        />
                      }
                      fileName={`Quotation_${downloadQuotationdta?.data[0]?.company_name}-${quotation_id}-${downloadQuotationdta?.data[0]?.created_date ? moment(downloadQuotationdta?.data[0]?.created_date).format("MMMM-DD-YYYY") : ""}.pdf`}
                    >
                      {/* {({ blob, url, loading, error }) =>
                      loading ? (
                        "Loading document..."
                      ) : ( */}
                      <img
                        src="/assets/download.svg"
                        className=" h-full flex items-center downlaod-pdf justify-center"
                      ></img>
                      {/* )
                    } */}
                    </PDFDownloadLink>
                  ) : (
                    <img
                      src="/assets/download.svg"
                      className=" h-full flex items-center downlaod-pdf justify-center"
                      style={{ opacity: 0.4, cursor: "not-allowed" }}
                    ></img>
                  )}
                </Button>

                <Button className="flex items-center pdf-download-button">
                  <img
                    src="/assets/share.svg"
                    onClick={() => {
                      CopyButton();
                    }}
                    className="downlaod-pdf"
                  ></img>
                </Button>

                <Button
                  className="flex items-center downlaod-pdf"
                  onClick={() => {
                    if (editData?.data?.npd) {
                      navigate(
                        `/create-quotation?npd_id=${editData?.data?.npd}&quotation_id=${quotation_id}`,
                      );
                    }
                    if (editData?.data?.sales_lead) {
                      navigate(
                        `/create-quotation?id=${editData?.data?.sales_lead}&quotation_id=${quotation_id}`,
                      );
                    }
                  }}
                  disabled={printData?.data?.is_closed === true}
                >
                  <img src="/assets/edit-1.svg"></img>
                </Button>
              </Space>
            </div>
            <Dropdown
              overlay={widgetMenu}
              trigger={["click"]}
              className="dropdown-click"
            >
              <img
                src="/assets/option.svg"
                className="quotation-option-2"
              ></img>
            </Dropdown>
            <div>
              <Space>
                <Button
                  onClick={() => {
                    handlePrevious();
                    // navigate(`/contacts?id=${object?.id}`);
                  }}
                  disabled={currentIndex === 0}
                >
                  <LeftOutlined />
                </Button>
                <Button
                  onClick={() => {
                    // navigate(`/contacts?id=${object?.id}`);
                    handleNext();
                  }}
                  disabled={currentIndex === data?.results?.length - 1}
                >
                  <RightOutlined />
                </Button>
              </Space>
            </div>
          </div>
        }
        width={600}
        placement="right"
        onClose={onClose}
        open={(isQuotationUrl as boolean) || open}
        destroyOnClose={true}
      >
        <AddNewQuotation
          setdata={setDownloadQuotationdta}
          setPreview={setOpen}
          setEditdata={setEditData}
        />
      </Drawer>

      {/* Export Modal for Quotations */}
      <ExportModal
        isModalOpen={isModalOpen}
        handleCancel={handleCancel}
        title="Quotations Export"
        columnOptions={columnOptions}
        selectedColumns={selectedColumns}
        setSelectedColumns={setSelectedColumns}
        handleDownload={handleExportDownload}
        isExporting={isExporting}
      >
        {/* Enquiry Category Filter */}
        <MultiSelectFilter
          value={enquiryCategoryIds}
          onChange={setEnquiryCategoryIds}
          options={enquiryCategoryData || []}
          label="Enquiry Category"
          placeholder="Select enquiry categories"
        />
        {/* Status Filter */}
        <MultiSelectFilter
          value={exportStatusFilter}
          onChange={setExportStatusFilter}
          options={statusFilterOptions}
          label="Status"
          placeholder="Select status"
        />
      </ExportModal>
    </>
  );
};
